import type { TourStepItem } from 'components/shared/GuidedTour/GuidedTour.steps';

/**
 * Steps definition, depending on the location of the user...
 * Be careful to not rename already persisted completed steps
 */
export const appFeedbackTourStepItems: TourStepItem[] = [{ id: 'menu.appFeedback' }];
